// Chakra imports
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import Footer from 'components/footer/FooterAuthDefault';
import FixedPlugin from 'components/fixedPlugin/FixedPlugin';
// Custom components
import { NavLink } from 'react-router-dom';
// Assets
import { FaChevronLeft } from 'react-icons/fa';

function AuthIllustration(props: {
  children: JSX.Element;
  illustrationBackground?: string;
}) {
  const { children, illustrationBackground } = props;
  const hasIllustration = Boolean(illustrationBackground);
  // Chakra color mode
  return (
    <Flex position="relative" h="max-content" overflow="hidden">
      {!hasIllustration ? (
        <Box
          position="absolute"
          inset="0"
          bgGradient="linear(135deg, #1e1b4b 0%, #312e81 48%, #4338ca 100%)"
        />
      ) : null}
      {!hasIllustration ? (
        <>
          <Flex
            position="absolute"
            inset="0"
            px={{ base: '24px', md: '50px', xl: '70px' }}
            pointerEvents="none"
            align="flex-end"
            pb={{ base: '110px', md: '90px' }}
          >
            <Box
              maxW="520px"
              color="white"
              bg="rgba(10,18,35,0.42)"
              border="1px solid rgba(255,255,255,0.10)"
              borderRadius="30px"
              px={{ base: 5, md: 7 }}
              py={{ base: 5, md: 6 }}
              boxShadow="0 20px 60px rgba(15, 23, 42, 0.25)"
            >
              <Text fontSize="xs" fontWeight="700" letterSpacing="0.18em" textTransform="uppercase" opacity="0.82" mb="10px">
                Plataforma Electoral
              </Text>
              <Text fontSize={{ base: '28px', md: '42px' }} lineHeight="1.02" fontWeight="800" mb="14px">
                Organiza campaña, territorio y voto desde un solo panel.
              </Text>
              <Text fontSize={{ base: 'sm', md: 'md' }} opacity="0.88" maxW="460px">
                Seguimiento de secciones, personal, agenda, compras y movimientos con enfoque territorial para operación electoral.
              </Text>
            </Box>
          </Flex>
        </>
      ) : null}
      <Flex
        position="relative"
        zIndex="1"
        h={{
          sm: 'initial',
          md: 'unset',
          lg: '100vh',
          xl: '97vh',
        }}
        w="100%"
        maxW={hasIllustration ? { md: '66%', lg: '1313px' } : '100%'}
        mx="auto"
        pt={{ sm: '50px', md: '0px' }}
        px={{ lg: '30px', xl: '0px' }}
        ps={hasIllustration ? { xl: '70px' } : '0px'}
        justifyContent={hasIllustration ? 'start' : 'center'}
        direction="column"
        alignItems={hasIllustration ? 'stretch' : 'center'}
      >
        <NavLink
          to="/admin"
          style={() => ({
            width: 'fit-content',
            marginTop: '40px',
          })}
        >
          <Flex
            align="center"
            ps={{ base: '25px', lg: '0px' }}
            pt={{ lg: '0px', xl: '0px' }}
            w="fit-content"
          >
            <Icon
              as={FaChevronLeft}
              me="12px"
              h="13px"
              w="8px"
              color="secondaryGray.600"
            />
            <Text ms="0px" fontSize="sm" color="secondaryGray.600">
              Regresa al Dashboard
            </Text>
          </Flex>
        </NavLink>
        {children}
        {illustrationBackground ? (
          <Box
            display={{ base: 'none', md: 'block' }}
            h="100%"
            minH="100vh"
            w={{ lg: '50vw', '2xl': '44vw' }}
            position="absolute"
            right="0px"
            bgGradient="linear(to-b, brand.400, brand.600)"
            borderBottomLeftRadius={{ lg: '120px', xl: '200px' }}
          >
            <Flex
              alignSelf={'center'}
              bg={`url(${illustrationBackground})`}
              justify="center"
              align="center"
              w="80%"
              h="80%"
              bgSize="cover"
              bgPosition="80%"
              position="absolute"
            />
          </Box>
        ) : null}
        <Footer />
      </Flex>
      <FixedPlugin />
    </Flex>
  );
}
// PROPS

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
